import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import { showSpinner, hideSpinner } from 'action/spinner'
import { getPages } from 'component/pagination/utils'
import { createQueryParams } from 'utils/CreateQueryUtils'

import {
  FETCH_SCHEDULE_BLOCK_REQUEST,
  FETCH_SCHEDULE_BLOCK_SUCCESS,
  FETCH_SCHEDULE_BLOCK_ERROR,
  SAVE_SCHEDULE_BLOCK_REQUEST,
  SAVE_SCHEDULE_BLOCK_SUCCESS,
  SAVE_SCHEDULE_BLOCK_ERROR,
  DELETE_SCHEDULE_BLOCK_REQUEST,
  DELETE_SCHEDULE_BLOCK_SUCCESS,
  DELETE_SCHEDULE_BLOCK_ERROR,
  FETCH_BRANCHS_REQUEST,
  FETCH_BRANCHS_SUCCESS,
  FETCH_BRANCHS_ERROR,
} from 'actionTypes'

export const fetchBranchs = (dsToken) => (dispatch) => {
  dispatch(featchBranchsRequest())

  return new Api(dsToken, dispatch)
    .post(API_URL.BRANCHES)
    .then(dispatch(showSpinner()))
    .then(
      (response) => {
        dispatch(fetchBranchsSuccess(response.data))
      },
      (error) => {
        dispatch(fetchBranchsError(error))
      }
    )
    .finally(hideSpinner())
}

export const featchBranchsRequest = () => ({
  type: FETCH_BRANCHS_REQUEST,
})

export const fetchBranchsSuccess = (data = []) => {
  const brachs = data.map((e) => ({ value: e.id, label: e.name }))
  return {
    type: FETCH_BRANCHS_SUCCESS,
    payload: brachs,
  }
}

export const fetchBranchsError = (error) => ({
  type: FETCH_BRANCHS_ERROR,
  payload: error,
})

/*
 * REQUEST SCHEDULE BLOCK
 */
export const fetchScheduleBlock = (auth, filters, page, size, orderDirection) => (dispatch) => {
  dispatch(fetchScheduleBlockRequest())

  const metadata = {
    page,
    size,
    orderDirection
  }

  const endpoint = `${API_URL.SCHEDULE_BRANCH_LIST}?${createQueryParams(
    metadata
  )}`


  const payload = {
    ...filters,
    orderDirection
  };

  return new Api(auth.user.dsToken, dispatch)
    .post(endpoint, payload)
    .then(dispatch(showSpinner()))
    .then((response) => {
      dispatch(getPages(response.data.pages))
      dispatch(fetchScheduleBlockSuccess(response.data.resultList, filters))
      dispatch(hideSpinner())
    })
    .catch((error) => {
      dispatch(fetchScheduleBlockError(error, filters))
      dispatch(hideSpinner())
    })
}

export const fetchScheduleBlockRequest = () => ({
  type: FETCH_SCHEDULE_BLOCK_REQUEST,
})

export const fetchScheduleBlockSuccess = (data, filters) => ({
  type: FETCH_SCHEDULE_BLOCK_SUCCESS,
  payload: data,
  filters,
})

export const fetchScheduleBlockError = (error, filters) => ({
  type: FETCH_SCHEDULE_BLOCK_ERROR,
  payload: error,
  filters,
})

/*
 * SAVE SCHEDULE BLOCK
 */
export const updateScheduleBlock =
  (auth, toSave = null, callback) =>
  (dispatch) => {
    dispatch(updateScheduleBlockRequest())

    return new Api(auth.user.dsToken, dispatch)
      .post(API_URL.SCHEDULE_BRANCH_SAVE, toSave)
      .then(dispatch(showSpinner()))
      .then((response) => {
        dispatch(updateScheduleBlockSuccess(response.data))
        callback && callback()
        dispatch(hideSpinner())
      })
      .catch((error) => {
        dispatch(updateScheduleBlockError(error))
        dispatch(hideSpinner())
      })
  }

export const updateScheduleBlockRequest = () => ({
  type: SAVE_SCHEDULE_BLOCK_REQUEST,
})

export const updateScheduleBlockSuccess = (data) => ({
  type: SAVE_SCHEDULE_BLOCK_SUCCESS,
  payload: data,
})

export const updateScheduleBlockError = (error) => ({
  type: SAVE_SCHEDULE_BLOCK_ERROR,
  payload: { error },
})

/*
 * DELETE SCHEDULE BLOCK
 */
export const deleteScheduleBlock = (auth, toRemove) => (dispatch) => {
  dispatch(deleteScheduleBlockRequest())

  return new Api(auth.user.dsToken, dispatch)
    .post(API_URL.SCHEDULE_BRANCH_DELETE_MULTIPLE, toRemove)
    .then(dispatch(showSpinner()))
    .then((response) => {
      dispatch(deleteScheduleBlockSuccess(response.data))
      dispatch(hideSpinner())
    })
    .catch((error) => {
      dispatch(deleteScheduleBlockError(error))
      dispatch(hideSpinner())
    })
}

export const deleteScheduleBlockRequest = () => ({
  type: DELETE_SCHEDULE_BLOCK_REQUEST,
})

export const deleteScheduleBlockSuccess = (data) => ({
  type: DELETE_SCHEDULE_BLOCK_SUCCESS,
  payload: data,
})

export const deleteScheduleBlockError = (error) => ({
  type: DELETE_SCHEDULE_BLOCK_ERROR,
  payload: { error },
})
